<template>
  <div class="waajo-dashboard">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid waajo-dashboard-content">
          <header class="waajo-dashboard-head" data-tour-step="dashboard-welcome">
            <div class="waajo-dashboard-greeting">
              <span class="waajo-dashboard-eyebrow">Dashboard</span>
              <h1>Halo, {{ memberName }}!</h1>
              <p>Berikut ringkasan akun WhatsApp Anda hari ini.</p>
            </div>

            <div class="waajo-dashboard-tools">
              <div class="waajo-period-chip">
                <i class="fa fa-calendar-o" aria-hidden="true"></i>
                <span>{{ periodLabel }}</span>
              </div>

              <div class="waajo-account-chip" v-if="activeLicensePhone">
                <span class="waajo-account-wa" aria-hidden="true">
                  <i class="fa fa-whatsapp"></i>
                </span>
                <span class="waajo-account-copy">
                  <strong>{{ activeLicensePhone }}</strong>
                  <small :title="activeLicenseExpiry || activeLicenseName">{{ activeLicenseName }}</small>
                </span>
                <span
                  class="waajo-account-dot"
                  :class="{ 'is-online': activeLicenseOnline }"
                  :title="activeLicenseOnline ? 'Online' : 'Offline'"
                ></span>
              </div>
              <router-link v-else to="/license/list" class="waajo-account-chip is-empty">
                <span class="waajo-account-wa" aria-hidden="true">
                  <i class="fa fa-whatsapp"></i>
                </span>
                <span class="waajo-account-copy">
                  <strong>Pilih akun WhatsApp</strong>
                  <small>Belum ada lisensi aktif</small>
                </span>
              </router-link>

              <!-- <div class="dropdown waajo-help-menu">
                <button
                  type="button"
                  class="waajo-help-button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  aria-label="Bantuan dashboard"
                >
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a class="dropdown-item" href="javascript:void(0)" @click.prevent="tourShow">
                    <i class="fa fa-compass" aria-hidden="true"></i> Tour Guide
                  </a>
                  <a
                    class="dropdown-item"
                    target="_blank"
                    rel="noopener"
                    href="https://www.youtube.com/channel/UCvW5ivbvIoBCyC4tXhHbh5A"
                  >
                    <i class="fa fa-play-circle" aria-hidden="true"></i> Tutorial Video
                  </a>
                </div>
              </div> -->
            </div>
          </header>

          <section
            v-if="showModalOnlineDemo != 'hide'"
            class="waajo-demo-banner"
            aria-label="Informasi demo online"
          >
            <div class="waajo-demo-copy">
              <span class="waajo-demo-kicker">Konsultasi Gratis</span>
              <strong>Jadwalkan demo online bersama tim Waajo.</strong>
              <p>
                Kenali cara mengelola WhatsApp, broadcast, dan follow-up
                pelanggan dalam satu dashboard.
              </p>
            </div>
            <div class="waajo-demo-actions">
              <a
                target="_blank"
                rel="noopener"
                href="https://waajo.id/?fluent-booking=calendar&host=farmalite&event=30min"
                class="waajo-demo-primary"
              >
                <i class="fa fa-calendar" aria-hidden="true"></i>
                Jadwalkan
              </a>
              <button type="button" class="waajo-demo-secondary" @click="closeModalOnlineDemo">
                Lain Kali
              </button>
            </div>
          </section>

          <section class="waajo-stats-grid" aria-label="Ringkasan akun" data-tour-step="dashboard-stats">
            <router-link to="/ai/pricing" class="waajo-stat-card">
              <span class="waajo-stat-icon is-token" aria-hidden="true">
                <i class="fa fa-magic"></i>
              </span>
              <span class="waajo-stat-content">
                <strong v-if="!statsLoading.token">{{ nFormatter(rowTotalTokenAI.total_tokens) }}</strong>
                <span v-else class="waajo-stat-loading"></span>
                <span class="waajo-stat-label">Saldo Token AI <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </span>
            </router-link>

            <button type="button" class="waajo-stat-card" @click="redirectToLicenseByClick">
              <span class="waajo-stat-icon is-wa" aria-hidden="true">
                <i class="fa fa-whatsapp"></i>
              </span>
              <span class="waajo-stat-content">
                <strong v-if="!statsLoading.licenses">{{ nFormatter(numLicenseTotal) }}</strong>
                <span v-else class="waajo-stat-loading"></span>
                <span class="waajo-stat-label">Akun WhatsApp <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </span>
            </button>

            <router-link to="/contacts-v2" class="waajo-stat-card">
              <span class="waajo-stat-icon is-contact" aria-hidden="true">
                <i class="fa fa-user-o"></i>
              </span>
              <span class="waajo-stat-content">
                <strong v-if="!statsLoading.contacts">{{ nFormatter(numContactsTotal) }}</strong>
                <span v-else class="waajo-stat-loading"></span>
                <span class="waajo-stat-label">Kontak <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </span>
            </router-link>

            <router-link to="/message_report/outbox" class="waajo-stat-card">
              <span class="waajo-stat-icon is-message" aria-hidden="true">
                <i class="fa fa-envelope-o"></i>
              </span>
              <span class="waajo-stat-content">
                <strong v-if="!statsLoading.messages">{{ nFormatter(numMessageTotal) }}</strong>
                <span v-else class="waajo-stat-loading"></span>
                <span class="waajo-stat-label">Pesan Terkirim <i class="fa fa-angle-right" aria-hidden="true"></i></span>
              </span>
            </router-link>
          </section>

          <license-renewal data-tour-step="dashboard-renewal"></license-renewal>

          <section class="waajo-widgets">
            <graph-broadcast />
            <chat-bot />
            <stat2 />
            <graph-sum-license />
            <!-- <billing /> -->
          </section>
        </div>
      </div>
    </div>

    <v-tour
      class="waajo-tour"
      name="tourGuide"
      :steps="availableTourSteps"
      :callbacks="tourCallbacks"
      :options="tourOptions"
    ></v-tour>
  </div>
</template>

<script>
import graphBroadcast from "./components/graphBroadcast.vue";
//import Billing from "./components/billing.vue";
import ChatBot from "./components/ChatBot.vue";
import Stat2 from "./components/Stat2.vue";
import GraphSumLicense from "./components/graphSumLicense.vue";
import LicenseRenewal from "./components/LicenseRenewal.vue";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { nFormatter } from "@/utils/helper";
import {
  formatDateRangeForMonth,
  formatLicenseDate,
  getLicenseExpiryInfo
} from "@/utils/licenseExpiry";
import { mapGetters } from "vuex";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    LicenseRenewal,
  //  Billing,
    graphBroadcast,
    GraphSumLicense,
    ChatBot,
    Stat2
  },
  data() {
    return {
      rowTotalTokenAI: {
        total_tokens: "0",
        total_tokens_used: "0"
      },
      aiDetail: {
        ai_engine: "",
        trial_status: 1,
        trial_expire: 0
      },
      contactWaajo: process.env.VUE_APP_CONTACT_WAAJO,
      statsLoading: {
        token: true,
        licenses: true,
        contacts: true,
        messages: true
      },
      tourId: "dashboard.admin",
      tourVersion: "v2",
      tourOptions: {
        highlight: true,
        startTimeout: 250,
        labels: {
          buttonSkip: "Lewati",
          buttonPrevious: "Sebelumnya",
          buttonNext: "Berikutnya",
          buttonStop: "Selesai"
        }
      },
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      availableTourSteps: [],
      tourSteps: [
        {
          target: '[data-tour-step="dashboard-welcome"]',
          header: {
            title: "Selamat Datang di Dashboard Waajo"
          },
          content:
            "Pantau aktivitas WhatsApp, performa pengiriman pesan, dan ringkasan penggunaan Waajo dari satu halaman.",
          params: { placement: "bottom" }
        },
        {
          target: '[data-tour-step="dashboard-stats"]',
          header: {
            title: "Pantau Aktivitas Anda"
          },
          content:
            "Lihat ringkasan saldo token AI, jumlah akun WhatsApp, kontak, dan pesan terkirim melalui kartu statistik yang tersedia.",
          params: { placement: "bottom" }
        },
        {
          target: '[data-tour-step="dashboard-renewal"]',
          header: {
            title: "Pantau Masa Aktif Lisensi"
          },
          content:
            "Lisensi yang mendekati tanggal kedaluwarsa atau baru saja berakhir akan ditampilkan di bagian ini. Gunakan tombol Pilih Paket untuk melanjutkan ke proses perpanjangan jika tersedia.",
          params: { placement: "top" }
        },
        {
          target: '[data-tour-step="dashboard-daily"]',
          header: {
            title: "Pantau Pengiriman Pesan"
          },
          content:
            "Gunakan grafik statistik harian untuk memahami jumlah pesan berhasil, gagal, tertunda, atau status lain yang ditampilkan oleh dashboard.",
          params: { placement: "top" }
        },
        {
          target: '[data-tour-step="dashboard-schedule"]',
          header: {
            title: "Lihat Jadwal Broadcast"
          },
          content:
            "Pantau broadcast terjadwal dan statusnya langsung dari dashboard jika bagian tersebut tersedia.",
          params: { placement: "top" }
        }
      ]
    };
  },
  computed: {
    showModalOnlineDemo() {
      return this.$store.state.login.showModalOnlineDemo;
    },
    ...mapGetters(["fieldsGetLicenseList", "agentSession"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession || {};
    },
    memberName() {
      return (
        this.memberSessionArr.name ||
        this.memberSessionArr.email ||
        "Pengguna Waajo"
      );
    },
    numLicenseTotal() {
      return this.$store.state.member.numLicenseTotal;
    },
    numAgentTotal() {
      return this.$store.state.member.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.member.numMessageTotal;
    },
    numActiveVoucherTotal() {
      return this.$store.state.member.numActiveVoucherTotal;
    },
    numContactsTotal() {
      return this.$store.state.member.numContactsTotal;
    },
    activeLicensePhone() {
      return this.agentSession ? this.agentSession.license_phone_number || "" : "";
    },
    activeLicenseName() {
      return this.agentSession
        ? this.agentSession.license_name || "Lisensi WhatsApp"
        : "Lisensi WhatsApp";
    },
    activeLicenseOnline() {
      return this.agentSession
        ? Number(this.agentSession.is_online_status) === 1
        : false;
    },
    activeLicenseExpiry() {
      if (!this.agentSession) {
        return "";
      }
      if (Number(this.agentSession.is_unlimited) === 1) {
        return "Masa aktif tanpa batas";
      }
      if (!this.agentSession.license_masa_aktif) {
        return "";
      }
      const label = formatLicenseDate(this.agentSession.license_masa_aktif);
      if (!label) {
        return "";
      }
      const info = getLicenseExpiryInfo(this.agentSession.license_masa_aktif);
      if (info.state === "expired") {
        return "Kedaluwarsa sejak " + label;
      }
      return "Masa aktif hingga " + label;
    },
    periodLabel() {
      return formatDateRangeForMonth(new Date());
    }
  },
  created() {
    this.getLicenseTotal();
    this.getContactsTotal();
    this.getMessageTotal();
    this.$store.dispatch("member/getActiveVoucherTotal").catch(function() {});
    this.tourDetail();
    this.getAIDetail();
    this.getTotalTokenAI();
  },
  methods: {
    nFormatter(value) {
      return nFormatter(value);
    },
    async getTotalTokenAI() {
      this.statsLoading.token = true;
      try {
        const response = await this.$store.dispatch("dashboard/TotalTokenAI");
        this.rowTotalTokenAI = (response && response.data) || {
          total_tokens: "0",
          total_tokens_used: "0"
        };
      } catch (error) {
        this.rowTotalTokenAI = {
          total_tokens: "0",
          total_tokens_used: "0"
        };
      } finally {
        this.statsLoading.token = false;
      }
    },
    async getAIDetail() {
      try {
        const response = await this.$store.dispatch("aiKey/getDetail");
        this.aiDetail = (response && response.data) || this.aiDetail;
      } catch (error) {
        // Detail AI tidak wajib untuk statistik utama dashboard.
      }
    },
    async getLicenseTotal() {
      this.statsLoading.licenses = true;
      try {
        await this.$store.dispatch("member/getLicenseTotal");
      } catch (error) {
        // Nilai default dari store tetap ditampilkan.
      } finally {
        this.statsLoading.licenses = false;
      }
    },
    async getContactsTotal() {
      this.statsLoading.contacts = true;
      try {
        await this.$store.dispatch("member/getContactsTotal");
      } catch (error) {
        // Nilai default dari store tetap ditampilkan.
      } finally {
        this.statsLoading.contacts = false;
      }
    },
    async getMessageTotal() {
      this.statsLoading.messages = true;
      try {
        await this.$store.dispatch("member/getMessageTotal", {
          provider: "whatsapp"
        });
      } catch (error) {
        // Nilai default dari store tetap ditampilkan.
      } finally {
        this.statsLoading.messages = false;
      }
    },
    getAgentTotal() {
      this.$store.dispatch("member/getAgentTotal");
    },
    closeModalOnlineDemo() {
      this.$store.dispatch("login/actHideModalOnlineDemo");
    },
    redirectToLicenseByClick() {
      this.fieldsGetLicenseList.license_status = "";
      this.$router.push({ path: "/license/list" });
    },
    tourShow() {
      this.availableTourSteps = this.tourSteps.filter(step => {
        const element = document.querySelector(step.target);
        return !!(
          element &&
          (element.offsetWidth ||
            element.offsetHeight ||
            element.getClientRects().length)
        );
      });

      if (!this.availableTourSteps.length) {
        return;
      }

      this.startTourWhenReady();
    },
    startTourWhenReady(attempt = 0) {
      this.$nextTick(() => {
        if (this.$tours && this.$tours.tourGuide) {
          this.$tours.tourGuide.start();
          return;
        }
        if (attempt < 20) {
          window.setTimeout(() => this.startTourWhenReady(attempt + 1), 100);
        }
      });
    },
    tourStorageKey() {
      const session = this.$store.getters.agentSession || {};
      const account =
        session.network_id || session.license_id || "anonymous";
      return "waajo.tour." + this.tourId + "." + this.tourVersion + "." + account;
    },
    hasSeenTourVersion() {
      try {
        return window.localStorage.getItem(this.tourStorageKey()) === "done";
      } catch (error) {
        return false;
      }
    },
    markTourVersionComplete() {
      try {
        window.localStorage.setItem(this.tourStorageKey(), "done");
      } catch (error) {
        // Tour tetap diselesaikan walau browser memblokir localStorage.
      }
    },
    tourComplete() {
      this.markTourVersionComplete();
      this.$store.dispatch("tour/tourComplete", {
        tour_id: this.tourId
      });
    },
    tourDetail() {
      this.$store
        .dispatch("tour/tourDetail", { tour_id: this.tourId })
        .then(() => {
          if (!this.hasSeenTourVersion()) {
            this.tourShow();
          }
        })
        .catch(function() {});
    }
  },
  name: "waajo-dashboard"
};
</script>

<style src="./dashboard.css"></style>



// WEBPACK FOOTER //
// src/views/dashboard/copilot.vue